export default {
  createdDate: {
    asc: 'createdDate_ASC',
    desc: 'createdDate_DESC',
  },
  name: {
    asc: 'name_ASC',
    desc: 'name_DESC',
  },
  serviceType: {
    asc: 'serviceType_ASC',
    desc: 'serviceType_DESC',
  },
  transactionType: {
    asc: 'transactionType_ASC',
    desc: 'transactionType_DESC',
  },
  salesChannel: {
    asc: 'salesChannel_ASC',
    desc: 'salesChannel_DESC',
  },
  marketSegment: {
    asc: 'marketSegment_ASC',
    desc: 'marketSegment_DESC',
  },
  accountType: {
    asc: 'accountType_ASC',
    desc: 'accountType_DESC',
  },
  accountSubType: {
    asc: 'accountSubType_ASC',
    desc: 'accountSubType_DESC',
  },
  status: {
    asc: 'status_ASC',
    desc: 'status_DESC',
  },
};
